export default {
  setActive(state, item) {
    state.active = item;
  },

  stop(state) {
    state.stopped = true;
  },

  start(state) {
    if (!this.state.dataLayer.clicked) {
      state.stopped = false;
    }
  },
};
